import React from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import Icon from 'components/DesignSystem/Icon';
import { BLUE, GRAY } from 'constants/colors';
import './index.scss';

export default function SubmissionProgressIndicator({ isVisible, progress }: {
  isVisible: boolean,
  progress: number,
}) {
  if (isVisible) {
    return (
      <div className="submission-progress-indicator">
        <CircularProgressbarWithChildren
          value={progress}
          background
          styles={buildStyles({
            backgroundColor: 'white',
            strokeLinecap: 'butt',
            trailColor: GRAY,
            pathColor: BLUE,
            pathTransitionDuration: 0.3,
          })}
          strokeWidth={3}
        >
          <Icon iconType="send" />
        </CircularProgressbarWithChildren>
      </div>
    );
  }

  return null;
}
